import React from 'react';
import './logo.css';

type LogoProps = {
  variant?: 'nav' | 'footer';
  className?: string;
};

/**
 * Typographic wordmark: strong “Aegis” + rule + monospace “AI”.
 */
export const Logo: React.FC<LogoProps> = ({ variant = 'nav', className = '' }) => (
  <span className={`wordmark wordmark--${variant} ${className}`.trim()}>
    <span className="wordmark__name">Aegis</span>
    <span className="wordmark__rule" aria-hidden />
    <span className="wordmark__suffix">AI</span>
  </span>
);

type LogoLinkProps = LogoProps & {
  href?: string;
};

export const LogoLink: React.FC<LogoLinkProps> = ({
  variant = 'nav',
  className = '',
  href = '/',
}) => (
  <a
    className={`wordmark-link ${className}`.trim()}
    href={href}
    aria-label="Aegis AI home"
  >
    <Logo variant={variant} />
  </a>
);
